import styled from '@emotion/styled';

import { COLOR_TEXT_PRIMARY } from './utils/variables';

export const DetailValue = styled.div`
  font-size: 14px;
  color: ${COLOR_TEXT_PRIMARY};
  line-height: 1.45;
`;
